import StakeholderIndex from '@pages/stakeholders/StakeholderIndex'
import StakeholderResponses from '@pages/stakeholders/StakeholderResponses'
import { beforeRouteEnterAction } from '@router/router.utils'

export default [
  {
    path: '/stakeholders',
    name: 'stakeholders',
    component: StakeholderIndex,
    meta: {
      requiresAuth: true,
      actions: ['stakeholders/getAll'],
      pageTitle: 'Stakeholders',
      pathToLocalization: 'stakeholders.title'
    },
    beforeEnter: beforeRouteEnterAction
  },
  {
    path: '/stakeholder-responses/:id/subscriptions',
    name: 'stakeholder-responses',
    component: StakeholderResponses,
    meta: {
      requiresAuth: false,
      pageTitle: 'Subscriptions Feedback',
      pathToLocalization: 'stakeholder-responses.title',
      actions: ['stakeholders/getResponses']
    },
    beforeEnter: beforeRouteEnterAction
  }
]
